import { c as _c } from "react/compiler-runtime";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
export const Delete = t0 => {
  const $ = _c(5);
  const {
    onClick,
    color: t1
  } = t0;
  const color = t1 === undefined ? "inherit" : t1;
  let t2;
  if ($[0] !== color) {
    t2 = {
      color,
      cursor: "pointer"
    };
    $[0] = color;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick || $[3] !== t2) {
    t3 = <DeleteOutlineOutlinedIcon sx={t2} onClick={onClick} />;
    $[2] = onClick;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};